import { render, staticRenderFns } from "./oilHotalMiddlePage.vue?vue&type=template&id=109e54f6&scoped=true&"
import script from "./oilHotalMiddlePage.vue?vue&type=script&lang=js&"
export * from "./oilHotalMiddlePage.vue?vue&type=script&lang=js&"
import style0 from "./oilHotalMiddlePage.vue?vue&type=style&index=0&id=109e54f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109e54f6",
  null
  
)

export default component.exports